import React from "react";
import { Link } from "react-router-dom";
import { Btn } from "../UI"; // Assuming this handles its own dark mode or is transparent

export default function CTA() {
  return (
    <section className="py-20 px-6 bg-slate-50 dark:bg-gradient-to-b dark:from-[#0d1f3c] dark:to-[#1a3358] transition-colors duration-200">
      <div className="max-w-[640px] mx-auto text-center font-['Plus_Jakarta_Sans',sans-serif]">
        
        <div className="text-[clamp(26px,4vw,38px)] font-extrabold text-slate-900 dark:text-white mb-3 leading-[1.2]">
          Ready to Put Your Career<br />on the Fast Lane?
        </div>
        
        <p className="text-base text-slate-600 dark:text-white/70 mb-8 leading-relaxed">
          Join thousands of certified pilot car professionals on the only platform built specifically for this industry.
        </p>
        
        <div className="flex gap-3.5 justify-center flex-wrap mb-6">
          <Link to="/signup" className="text-decoration-none">
            <Btn sz="xl">🚗 I'm a Driver →</Btn>
          </Link>
          <Link to="/signup" className="text-decoration-none">
            <Btn
              sz="xl"
              v="outline"
              className="border-blue-600 text-blue-600 dark:border-amber-400 dark:text-amber-400 hover:bg-blue-50 dark:hover:bg-amber-400/10"
            >
              🏢 I'm a Company →
            </Btn>
          </Link>
        </div>
        
        <div className="flex gap-5 justify-center flex-wrap">
          {["Free to browse", "No credit card to start", "Cancel anytime"].map((t) => (
            <div key={t} className="flex items-center gap-1.5 text-[13px] text-slate-500 dark:text-white/60">
              <span className="text-emerald-500 dark:text-emerald-400 font-bold">✓</span>
              {t}
            </div>
          ))}
        </div>
        
      </div>
    </section>
  );
}